import {
    Expander,
    ExpanderTheme,
    ExpanderButtonStyle,
    ExpanderBorderRoundingStyle,
    ExpanderBorderStyle,
    Panel,
    PanelTheme,
    PanelBorderStyle,
    PanelBorderRadius,
    ButtonTheme,
    Button,
} from '@apply/components';
import { BorrowerForm } from '../../Borrower/BorrowerForm';
import { isMobileScreen } from '@apply/ui';
import { useNavigate } from 'react-router';
import { useBorrowerEntityName } from '../../../queries/BorrowerFields/EntityFields';

export interface BorrowerReviewPanelProps {
    printMode?: boolean;
    entryGuid: string | undefined;
    token: string | null;
}

export const BorrowerReviewPanel: React.FC<BorrowerReviewPanelProps> = ({ printMode = false, entryGuid, token }) => {
    const [borrowerEntityName] = useBorrowerEntityName();
    const navigate = useNavigate();
    const formatLinkDestination = (token?: string | null): string => {
        return `/borrower/${entryGuid ? entryGuid : ''}${token ? '?token=' + token : ''}`;
    };

    const editBorrowerClick = () => {
        navigate(formatLinkDestination(token));
    };

    const renderHeader = () => {
        return (
            <>
                <div className='borrowerReviewPanel-header'>
                    <div className='borrowerReviewPanel-header-left'>
                        <div className='borrowerReviewPanel-header-left-content'>
                            <div className='borrowerReviewPanel-header-left-content-label'>
                                <h4>Borrower</h4>
                            </div>
                            <div className='borrowerReviewPanel-header-left-content-entityName'>{borrowerEntityName}</div>
                        </div>
                    </div>
                    <div className='borrowerReviewPanel-header-right'>
                        <Button
                            id='editBorrowerButton'
                            theme={ButtonTheme.LinkBlue}
                            visible={!printMode}
                            handleClick={editBorrowerClick}
                        >
                            Edit
                        </Button>
                    </div>
                </div>
            </>
        );
    };

    return (
        <div className='borrowerReviewPanel'>
            <Expander
                theme={ExpanderTheme.Glass}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderRoundingStyle={ExpanderBorderRoundingStyle.Rounded}
                borderStyle={ExpanderBorderStyle.Solid}
                header={renderHeader()}
                initialExpanded={true}
                height={isMobileScreen() ? '65px' : '50px'}
                expandOnButtonClickOnly={true}
            >
                <div className={`borrowerReviewPanel-content-${isMobileScreen() ? 'mobile' : 'nonMobile'}`}>
                    <Panel
                        theme={PanelTheme.White}
                        borderStyle={isMobileScreen() ? PanelBorderStyle.None : PanelBorderStyle.Solid}
                        borderRadius={PanelBorderRadius.Small}
                    >
                        <BorrowerForm
                            entryGuid={entryGuid}
                            duplicateEntity={false}
                            isReview={true}
                        />
                    </Panel>
                </div>
            </Expander>
        </div>
    );
};
